import React from 'react';
import { defineMessages } from 'react-intl';
import Confirm from 'components/Confirm';
import Message from 'components/Message';

const messages = defineMessages({
  title: {
    id: 'yield-management.mark-class-as-not-full-confirmation-modal.title',
    defaultMessage: 'Are you sure?',
  },
  body: {
    id: 'yield-management.mark-class-as-not-full-confirmation-modal.body',
    defaultMessage:
      'This will re-open the session to ClassPass members and allow new reservations to be made. Are you sure you want to mark this session as no longer full?',
  },
  cancel: {
    id: 'yield-management.mark-class-as-not-full-confirmation-modal.cancel',
    defaultMessage: 'Cancel',
  },
  markAsNotFull: {
    id: 'yield-management.mark-class-as-not-full-confirmation-modal.turn-off',
    defaultMessage: 'Mark as not full',
  },
});

const MarkClassAsNotFullConfirmationModal = props => (
  <Confirm
    title={<Message message={messages.title} />}
    cancelNode={<Message message={messages.cancel} />}
    acceptNode={<Message message={messages.markAsNotFull} />}
    {...props}>
    <Message message={messages.body} />
  </Confirm>
);

export default MarkClassAsNotFullConfirmationModal;
